import React from "react"
import LawyerPageDropdown from "../UI/LawyerPageDropdown"

// Convert to React.memo to prevent unnecessary re-renders
const SearchDropdowns = React.memo(({
  selectedService,
  selectedArea,
  selectedSpecific,
  serviceOptions,
  areaOptions,
  specificOptions,
  onServiceChange,
  onAreaChange,
  onSpecificChange,
  isClearable = false
}) => {
  return (
    <div className="lawyer-profile-page__search-dropdowns">
      <div className={`lawyer-profile-page__dropdown-container ${selectedService ? 'has-value' : ''}`}>
        <LawyerPageDropdown
          options={serviceOptions}
          label="What services are you looking for?"
          value={selectedService}
          onChange={onServiceChange}
          isClearable={isClearable}
        />
      </div>

      <div className={`lawyer-profile-page__dropdown-container ${selectedArea ? 'has-value' : ''}`}>
        <LawyerPageDropdown
          options={areaOptions}
          label="Which area are you looking in?"
          value={selectedArea}
          onChange={onAreaChange}
          isClearable={isClearable}
        />
      </div>

      <div className={`lawyer-profile-page__dropdown-container ${selectedSpecific ? 'has-value' : ''}`}>
        <LawyerPageDropdown
          options={specificOptions}
          label="Are there any other specifics you need?"
          value={selectedSpecific}
          onChange={onSpecificChange}
          isClearable={isClearable}
        />
      </div>
    </div>
  )
})

export default SearchDropdowns 